import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
    leftPanel: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
    },
    leftPanelMargin: {
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginRight: MIDDLE_MARGIN,
        marginBottom: 0,
      },
    },
    testIcon: {
      width: 40,
      height: 40,
      marginRight: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginRight: MIDDLE_MARGIN,
      },
    },
    title: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      lineHeight: 1.2,
      fontSize: 18,
      marginBottom: 8,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
    description: {
      color: colorsPalette.gray,
      lineHeight: 1.5,
      fontSize: 16,
    },
    takeBtn: {
      '&$disabledBtn': {
        cursor: 'not-allowed',
        pointerEvents: 'all',
      },
    },
    disabledBtn: {},
    btn: {
      '&:hover $retakeIcon': {
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
    retakeIcon: {
      width: 14,
      height: 14,
      marginRight: 9,
    },
    link: {
      textAlign: 'center',
    },
  }),
);

export default useStyles;
